import { render, staticRenderFns } from "./block-preview.vue?vue&type=template&id=520765aa&scoped=true"
import script from "./block-preview.vue?vue&type=script&lang=js"
export * from "./block-preview.vue?vue&type=script&lang=js"
import style0 from "./block-preview.vue?vue&type=style&index=0&id=520765aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520765aa",
  null
  
)

export default component.exports